<template>
  <w-icon-wrapper icon-name='work-next-icon'>
    <g
      id='Gruppe_25438'
      data-name='Gruppe 25438'
    >
      <path
        id='Pfad_55737'
        d='M11.813,24.06a12,12,0,1,1,12-12A12,12,0,0,1,11.813,24.06Zm0-22a10,10,0,1,0,10,10A10.011,10.011,0,0,0,11.813,2.06Z'
        data-name='Pfad 55737'
        fill='currentColor'
        transform='translate(0.187 -0.06)'
      />
    </g>
    <path
      id='Pfad_55738'
      d='M18.832,12.72a.945.945,0,0,1-.077.078l-2.943,2.966a1,1,0,1,1-1.42-1.408l1.285-1.3H5.1a1,1,0,0,1,0-2h10.56l-1.32-1.283a1,1,0,0,1,1.4-1.434l3.787,3.68Z'
      data-name='Pfad 55738'
      fill='currentColor'
      transform='translate(0.187 -0.06)'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNext' };
</script>
